import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import GIF_LOADING from 'images/kick.gif';
import Spacer from 'Pages/Home/Components/Atoms/Spacer/Spacer';
import Style from './CheckingSpace.module.scss';

interface ICheckingSpaceProps {
  isOpen: boolean;
}

const CheckingSpace: React.FC<ICheckingSpaceProps> = (props) => {
  const { isOpen } = props;

  return (
    <Modal
      modalClassName="kick-notification-wrapper"
      isOpen={isOpen}
      className="kick-modal modal-upload-image-sell"
    >
      <ModalBody>
        <img src={GIF_LOADING} />
        <p style={{ textAlign: 'center' }}>
          <span className={Style['title']}>Hold On Tight</span>
          <Spacer height={8} />
          <span className={Style['description']}>
            We are checking warehouse space
          </span>
        </p>
      </ModalBody>
    </Modal>
  );
};

export default CheckingSpace;
